export default __webpack_public_path__ + "static/media/ic-back.a84aa91f.svg";